<template>
  <div id="subtitleCardRoot">
    <div id="titleContainer">
      <div :style="'font-size:'+ titleSize" id="title"><span v-html="title"></span></div>
      <div id="titleDescription"><span v-html="description"></span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SubtitleCard",
  props: {
    height: {
      type: Number,
      default: 0
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    background: {
      type: String,
      default: ""
    },
    titleSize: {
      type: String,
      default: "4.5em"
    },
  },
}
</script>

<style lang="scss" src="../../styles/blog/subtitlecard.scss" scoped/>